import React from 'react';
import { connect } from 'react-redux';

import DeleteAccountSuccessModal from './DeleteAccountSuccessModal';

import { selectSuccess } from '../../../../redux/auth/deleteAccount/selectors';
import { cancelReload } from '../../../../redux/auth/deleteAccount/actions';

const DeleteAccountSuccessModalConnected = (props) => <DeleteAccountSuccessModal {...props} />;

const mapStateToProps = (state) => ({
  isVisible: selectSuccess(state),
});

const mapActionsToProps = {
  cancelReload,
};

export default connect(mapStateToProps, mapActionsToProps)(DeleteAccountSuccessModalConnected);
